import { render, staticRenderFns } from "./zhichu2QS.vue?vue&type=template&id=5a1e341c&scoped=true&"
import script from "./zhichu2QS.vue?vue&type=script&lang=js&"
export * from "./zhichu2QS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e341c",
  null
  
)

export default component.exports